// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { Moment } from 'moment';
import type { IAttributeTypeMap, RequestFile } from '@trialcard/shared';

export class DocumentLinkModel {
    'childDocumentId'?: number;
    'sequenceNumber'?: number;

    static readonly discriminator: string | undefined = undefined;

    static readonly additionalProperties = false;

    
    static readonly attributeTypeMap: ReadonlyArray<IAttributeTypeMap<keyof DocumentLinkModel>> = [
        {
            "name":     "childDocumentId",
            "baseName": "childDocumentId",
            "type":     "number"
        },
        {
            "name":     "sequenceNumber",
            "baseName": "sequenceNumber",
            "type":     "number"
        },
    ];

    static getAttributeTypeMap() {
        return DocumentLinkModel.attributeTypeMap;
    }
}
